export default {

  SEND_KAKAO (state, data) {
  }
}
